import React from 'react';
import Layout from '../../components/Layout';
import ContractsStatistics from './ContractsStatistics';

const DailyBookingReport = () => {
    return (
        <Layout title="Daily Rental Report">
            <ContractsStatistics />
        </Layout>
    );
};

export default DailyBookingReport;
